// lib/leasing/portfolio-display-utils.ts

export const formatEnumLabel = (value?: string | null) => {
  if (!value) return '-';
  return value.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, (c) => c.toUpperCase());
};

export const formatWebsiteLabel = (value?: string | null) => {
  if (!value) return null;
  return value.replace(/^https?:\/\//, '').replace(/\/$/, '');
};

export const normalizeWebsiteUrls = (value: unknown): string[] =>
  Array.from(
    new Set(
      (Array.isArray(value) ? value : [])
        .map((entry) => (typeof entry === 'string' ? entry.trim() : ''))
        .filter((entry) => entry.length > 0)
    )
  );

export const parseWebsiteUrlsText = (text: string): string[] =>
  Array.from(
    new Set(
      text
        .split(/[\n,;]/g)
        .map((entry) => entry.trim())
        .filter((entry) => entry.length > 0)
    )
  );

export const intentBadgeClass = (score?: number | null) => {
  if (score === null || score === undefined) return 'bg-[#979A9B]/10 text-[#979A9B] border-[#979A9B]/15';
  if (score >= 70) return 'bg-[#4DAB9A]/15 text-[#4DAB9A] border-[#4DAB9A]/20';
  if (score >= 40) return 'bg-[#FFA344]/15 text-[#FFA344] border-[#FFA344]/20';
  return 'bg-[#979A9B]/10 text-[#979A9B] border-[#979A9B]/15';
};
